__turbopack_context__.v({
  "markdown": "Markdown-module__y05AOG__markdown",
});
